import React from 'react';
import { Box } from '@mui/material';
import HeroSection from '../components/Homepage/HeroSection';
import BrandIntroduction from '../components/Homepage/BrandIntroduction';
import HomepageVisuals from '../components/Products/HomepageProducts';

// Full-bleed breakout (design 2a): the hero spans the whole viewport,
// escaping the layout Container's max-width, not just its gutters.
export const HERO_BREAKOUT_SX = {
  width: '100vw',
  marginLeft: 'calc(50% - 50vw)',
  marginTop: { xs: '-16px', sm: '-24px', md: '-32px' },
};

const HomePage = () => {
  return (
    <Box>
      <Box
        sx={HERO_BREAKOUT_SX}
      >
        <HeroSection />
      </Box>

      {/* Contained content - back to normal flow */}
      <BrandIntroduction />
      <HomepageVisuals />
    </Box>
  );
};

export default HomePage;
